import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Message, Grid, Checkbox } from "semantic-ui-react";
import { Header, IcoMoon, Button, PlaceHolder } from "../common";
import FormInput from "../common/Form/FormInput";
import FormDropdown from "../common/Form/FormDropdown";
import styles from "./styles.less";

class RegistrationForm extends React.Component {
  state = {
    registrationData: {},
    registrationErrors: {},
    termsAndConditionsRead: false,
    termsAndConditionsError: false,
    isFormSubmitted: false,
    formError: false,
    disabledFields: {},
    isAnalyticsLoaded: false
  };

  // updating user club details on registration form
  // on form mounted, if user is logged in as club member, update his details to form state.
  // on prop updates, check if user details has changed and update form state according to it.

  componentDidMount() {
    const { clubUserData, clubUserLoggedIn } = this.props;
    if (clubUserLoggedIn) {
      this.setClubUserDataToRegistration(clubUserData);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      clubUserLoggedIn,
      clubUserData: currentClubDetails,
      getAnalyticsPlaceHolders
    } = this.props;
    const { isAnalyticsLoaded } = this.state;

    if (clubUserLoggedIn) {
      if (
        (currentClubDetails && !prevProps.clubUserData) ||
        currentClubDetails.FirstName !== prevProps.clubUserData.FirstName ||
        currentClubDetails.LastName !== prevProps.clubUserData.LastName ||
        currentClubDetails.Email !== prevProps.clubUserData.Email
      ) {
        this.setClubUserDataToRegistration(currentClubDetails);
      }
    }
    if (!isAnalyticsLoaded && getAnalyticsPlaceHolders) {
      getAnalyticsPlaceHolders();
      this.setState({ isAnalyticsLoaded: true });
    }
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
  }

  setClubUserDataToRegistration = clubUserData => {
    const disabledFields = {
      FirstName: true,
      LastName: true,
      Email: true
    };

    this.setState({
      registrationData: {
        FirstName: clubUserData.FirstName,
        LastName: clubUserData.LastName,
        Email: clubUserData.Email
      },
      disabledFields: disabledFields
    });
  };

  // end updating user club details on registration form

  onSubmit = e => {
    e.preventDefault();
    const {
      onSubmit,
      togglePaymentSection,
      lang,
      scrollToRegistrationForm,
      isMobileView,
      isNoPayment
    } = this.props;
    const { termsAndConditionsRead, registrationData } = this.state;
    const formValid = this.validateForm();
    const countryValid =
      lang.toLowerCase() == "heb" ||
      (lang.toLowerCase() != "heb" && registrationData.Country);
    if (termsAndConditionsRead && formValid && countryValid) {
      this.setState({
        isFormSubmitted: true
      });
      onSubmit({ ...registrationData });
      if (!isNoPayment) {
        togglePaymentSection();
      }
    } else {
      if (isMobileView) {
        scrollToRegistrationForm();
      }
      this.setState({
        termsAndConditionsError: !termsAndConditionsRead,
        formError: true,
        countryError: !countryValid
      });
    }
  };

  openFormForEditing = () => {
    const { togglePaymentSection } = this.props;
    this.setState({ isFormSubmitted: false });
    togglePaymentSection();
  };

  resetRegistrationErrors = name => {
    const { registrationErrors } = this.state;
    const updatedReg = { ...registrationErrors };
    if (name && registrationErrors[name]) {
      updatedReg[name] = null;
      this.setState({ registrationErrors: updatedReg });
    } else if (registrationErrors) {
      this.setState({ registrationErrors: {} });
    }
  };

  validateForm = () => {
    const { registrationModel, titles } = this.props;
    const { registrationData } = this.state;
    const requiredFields = registrationModel.filter(m => m.required);
    let formValid = true;
    let registrationFormErrors = {};
    if (registrationData != null) {
      for (let element in requiredFields) {
        if (isNaN(element)) {
          return formValid;
        }
        let field = requiredFields && requiredFields[element];
        if (!registrationData[field && field.name]) {
          formValid = false;
        } else if (registrationData[field && field.name]) {
          if (
            field &&
            field.validation &&
            field.validation.minLength &&
            registrationData[field && field.name].length <
              field.validation.minLength
          ) {
            registrationFormErrors[field && field.name] =
              titles.ValidationTooShort;
            this.setState({ registrationErrors: registrationFormErrors });
            formValid = false;
          } else if (field && field.validation && field.validation.pattern) {
            let reg = new RegExp(field.validation.pattern);
            if (!reg.test(registrationData[field && field.name])) {
              registrationFormErrors[field && field.name] =
                titles.ValidationPatternMismatch;
              this.setState({ registrationErrors: registrationFormErrors });
              formValid = false;
            }
          } else {
            this.resetRegistrationErrors(field.name);
          }
        }
      }
    } else {
      this.resetRegistrationErrors();
      formValid = false;
    }
    return formValid;
  };

  OnInputChange = (value, name) => {
    const nextState = {
      registrationData: {
        ...this.state.registrationData,
        [name]: value
      }
    };
    this.setState(nextState);
  };

  // onInputBlur = () => {
  //   const { updateRegistrationData } = this.props;
  //   const formValid = this.validateForm();
  //   if (formValid) {
  //     updateRegistrationData(this.state.registrationData);
  //   }
  // };

  OnInputFocus = name => {
    const nextState = {
      registrationData: {
        ...this.state.registrationData,
        [name]: ""
      }
    };
    this.setState(nextState);
  };

  getEmailValidtionMsg = () => {
    const { titles } = this.props;
    let result = "";
    result = `${titles.ThisFieldIsMust},
        ${titles.ThisFieldNeedToBeEmailFormat}.`;
    return result;
  };

  getMessageContent = () => {
    const { titles } = this.props;
    //todo submitingStatus need to be from props
    const submitingStatus = {
      loading: false,
      error: false
    };
    let result = "";
    if (submitingStatus.error) result = titles.ContactFormErrorMessage;

    return result;
  };

  markTermsAndConditionsAsRead = () => {
    this.setState({
      termsAndConditionsRead: !this.state.termsAndConditionsRead,
      termsAndConditionsError: false
    });
  };

  renderRegistrationInputModel = (titles, registrationData, model) => {
    const {
      formError,
      registrationErrors,
      isFormSubmitted,
      disabledFields
    } = this.state;
    return (
      <FormInput
        className={styles.formInput}
        label={titles[model.name]}
        value={registrationData[model.name]}
        disabled={isFormSubmitted || disabledFields[model.name]}
        name={model.name}
        onChange={this.OnInputChange}
        error={formError && model.required && !registrationData[model.name]}
        errorMessage={registrationErrors && registrationErrors[model.name]}
        minLength={model.validation && model.validation.minLength}
        titles={titles}
        required={model.required}
        customValidation={model.required ? titles.ThisFieldIsMust : ""}
        pattern={model.validation && model.validation.pattern}
        type={model.validation && model.validation.type}
        key={model.name}
        placeholder={titles[model.name]}
        //onInputBlur={this.onInputBlur}
      />
    );
  };

  renderHeader = (headerTitle, isRtl, isMobileView, noSidePadding) => {
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <Header
            isRtl={isRtl}
            text={headerTitle + " :"}
            isMobileView={isMobileView}
            noSidePadding={noSidePadding}
          />
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderFormSection = (model, sectionHeader, key) => {
    const { titles } = this.props;
    const { registrationData } = this.state;
    const modelLength = model.length - 1;
    return (
      <div className={styles.sectionWrapper} key={key}>
        {sectionHeader && (
          <div className={styles.sectionHeader}>{sectionHeader}</div>
        )}
        {model &&
          model.map((elem, index) => {
            if (index * 2 <= modelLength) {
              const currentModel = model[index * 2];
              const nextModel =
                index * 2 + 1 <= modelLength && model[index * 2 + 1];
              const isLastRow = index * 2 + 2 <= modelLength;
              return (
                <Form.Group
                  className={cx(styles.inputsRow, {
                    [styles.lastRow]: !isLastRow
                  })}
                  widths="equal"
                  key={index}
                >
                  {currentModel != null &&
                    this.renderRegistrationInputModel(
                      titles,
                      registrationData,
                      currentModel
                    )}
                  {nextModel &&
                    this.renderRegistrationInputModel(
                      titles,
                      registrationData,
                      nextModel
                    )}
                </Form.Group>
              );
            }
          })}
      </div>
    );
  };

  renderForm = () => {
    const {
      titles,
      isMobileView,
      countries,
      isRtl,
      submitingStatus,
      lang,
      isNoPayment,
      termsAndConditions,
      registrationModel,
      registrationModelContact,
      showContactDetailsInRegistration,
      placeHolders
    } = this.props;
    const {
      termsAndConditionsRead,
      termsAndConditionsError,
      countryError,
      registrationData,
      isFormSubmitted
    } = this.state;
    return (
      <Form
        className={cx(styles.form, {
          [styles.rtl]: isRtl,
          [styles.mobileView]: isMobileView
        })}
        loading={submitingStatus.loading}
        error={submitingStatus.error}
      >
        <div
          className={cx(styles.formDataWrapper, {
            [styles.rtl]: isRtl,
            [styles.disabledForm]: isFormSubmitted
          })}
        >
          {this.renderFormSection(registrationModel, null, "registrationModel")}

          {showContactDetailsInRegistration &&
            this.renderFormSection(
              registrationModelContact,
              titles.ContactDetails,
              "registrationModelContact"
            )}

          {/* country select - only if enabled */}
          {lang.toLowerCase() != "heb" && (
            <div
              className={cx(
                styles.sectionWrapper,
                styles.nationalitySelectorWrapper
              )}
            >
              <Form.Group
                className={`${styles.inputsRow} ${styles.lastRow}`}
                widths="equal"
              >
                <FormDropdown
                  className={styles.formInput}
                  onChange={this.OnInputChange}
                  onInputFocus={this.OnInputFocus}
                  onInputBlur={this.OnInputChange}
                  options={countries}
                  name={titles.Country}
                  placeholder={""}
                  titles={titles}
                  displayInOneLine={true}
                  fullLength={false}
                  label={titles.SelectCountry}
                  required
                  customValidation={titles.ThisFieldIsMust}
                  isRtl={isRtl}
                  value={registrationData[titles.Country]}
                  error={countryError}
                  disabled={isFormSubmitted}
                  isMobileView={isMobileView}
                />
              </Form.Group>
            </div>
          )}
          <PlaceHolder
            placeHolders={placeHolders}
            component={"RegistrationPage"}
            location={"SpecialRequestsTop"}
          />
          {/* guest comments textbox */}
          <div
            className={cx(
              styles.sectionWrapper,
              styles.textAreaWrapper,
              styles.middleSection
            )}
          >
            <Form.Group
              className={cx(styles.inputsRow, styles.guestRemarksWrapper)}
              widths="equal"
            >
              <FormInput
                name={"GuestRemarks"}
                placeholder={titles.SpecialRequests}
                onChange={this.OnInputChange}
                value={registrationData["GuestRemarks"]}
                disabled={isFormSubmitted}
                titles={titles}
                textarea
                label={titles.SpecialRequests}
              />
            </Form.Group>
          </div>

          {/* terms and condition agreement and link to show */}
          <div
            className={cx(styles.checkBoxWrapper, {
              [styles.rtl]: isRtl,
              [styles.checkBoxWrapperError]: termsAndConditionsError,
              [styles.checkBoxWrapperDisabled]: isFormSubmitted
            })}
          >
            <Checkbox
              required
              onChange={this.markTermsAndConditionsAsRead}
              checked={termsAndConditionsRead}
              className={styles.checkBox}
              disabled={isFormSubmitted}
              label={
                <label className={styles.termsAndConditions}>
                  {titles.IAgree}
                  <a
                    href={termsAndConditions}
                    target="_blank"
                    className={styles.termsAndConditionsLink}
                  >
                    {titles.TermsAndConditions}
                  </a>
                </label>
              }
            />
            {termsAndConditionsError && (
              <div className={styles.checkBoxError}>
                {titles.TermsAndConditionsError}
              </div>
            )}
          </div>
        </div>
        {!isFormSubmitted && (
          <div className={styles.buttonWrapper}>
            <Button
              isSubmit={true}
              className={cx(styles.submitFormBtn, {
                [styles.mobileView]: isMobileView
              })}
              onClick={this.onSubmit}
              title={
                isNoPayment
                  ? titles.FinishReservation
                  : titles.ContinueToPayment
              }
            />
          </div>
        )}

        <Message
          visible={submitingStatus.error}
          error
          content={this.getMessageContent()}
        />
      </Form>
    );
  };

  handleRegistrationFormRef = node => {
    const { handleRegistrationFormRef } = this.props;
    if (handleRegistrationFormRef) {
      handleRegistrationFormRef(node);
    }
  };

  render() {
    const { isRtl, isMobileView, titles } = this.props;
    const { isFormSubmitted } = this.state;
    return (
      <Grid.Row className={styles.formWrapper}>
        <div
          className={styles.headerWrrapper}
          ref={this.handleRegistrationFormRef}
        >
          <Header
            isRtl={isRtl}
            text={titles.RegistrationTitle + ":"}
            isMobileView={isMobileView}
            noSidePadding={true}
          />
          {isFormSubmitted && (
            <Button
              isSubmit={true}
              onClick={this.openFormForEditing}
              className={cx(styles.editDetailsBtn, {
                [styles.mobileView]: isMobileView
              })}
            >
              <IcoMoon
                size="extrasmall"
                name="edit3"
                className={styles.editDetailsIcon}
              />
              {titles.EditDetails}
            </Button>
          )}
        </div>
        <Grid.Column width={16}>{this.renderForm()}</Grid.Column>
      </Grid.Row>
    );
  }
}

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  countries: PropTypes.array,
  isRtl: PropTypes.bool,
  termsAndConditions: PropTypes.string,
  submitingStatus: PropTypes.object,
  lang: PropTypes.string,
  registrationModel: PropTypes.array,
  clubUserLoggedIn: PropTypes.bool,
  clubUserData: PropTypes.object,
  registrationModelContact: PropTypes.array,
  showContactDetailsInRegistration: PropTypes.bool,
  togglePaymentSection: PropTypes.func,
  handleRegistrationFormRef: PropTypes.func,
  scrollToRegistrationForm: PropTypes.func,
  isNoPayment: PropTypes.bool,
  placeHolders: PropTypes.array,
  getAnalyticsPlaceHolders: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func
  //updateRegistrationData: PropTypes.func
  //registrationData: PropTypes.object
};

export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/components/RegistrationForm/RegistrationForm.js